"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUploadProfileImageResponseDto = instanceOfUploadProfileImageResponseDto;
exports.UploadProfileImageResponseDtoFromJSON = UploadProfileImageResponseDtoFromJSON;
exports.UploadProfileImageResponseDtoFromJSONTyped = UploadProfileImageResponseDtoFromJSONTyped;
exports.UploadProfileImageResponseDtoToJSON = UploadProfileImageResponseDtoToJSON;
exports.UploadProfileImageResponseDtoToJSONTyped = UploadProfileImageResponseDtoToJSONTyped;
var UploadedProfileImageDto_1 = require("./UploadedProfileImageDto");
/**
 * Check if a given object implements the UploadProfileImageResponseDto interface.
 */
function instanceOfUploadProfileImageResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function UploadProfileImageResponseDtoFromJSON(json) {
    return UploadProfileImageResponseDtoFromJSONTyped(json, false);
}
function UploadProfileImageResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, UploadedProfileImageDto_1.UploadedProfileImageDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function UploadProfileImageResponseDtoToJSON(json) {
    return UploadProfileImageResponseDtoToJSONTyped(json, false);
}
function UploadProfileImageResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, UploadedProfileImageDto_1.UploadedProfileImageDtoToJSON)(value['data']),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
